import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { FaxV1 } from '@frontend/api-fax';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useFaxReadEventSubscription = () => {
  const { updateFaxReadStatusInAllCaches } = FaxV1.FaxQueryUpdaters.useListFaxQueryUpdater();

  return useWebsocketEventSubscription(NotificationType.FAX_READ_STATUS_CHANGE, (payload) => {
    if (!payload.params.faxId) return;
    updateFaxReadStatusInAllCaches(payload.params.faxId, payload.params.markedRead ?? false);
  });
};
